export const DATA_VIEW_MAXIMUM_NODES_COUNT = 6;
export const NODE_CONFIG_SPACING = 50;
const CACHE_DURATION_MINS = 20;
export const CACHE_DURATION = CACHE_DURATION_MINS * 60 * 1000;
export const STALE_DURATION = (CACHE_DURATION_MINS / 2) * 60 * 1000;
